<template>
  <div class="device-management">
    <v-row align="center device-control-bar">
      <v-col cols="2">
        <v-select
          v-model="deviceType"
          :items="deviceTypes"
          label="Device Status"
          outlined
          @change="setDeviceTypeQuery"
        />
      </v-col>
      <v-col v-if="isAssigned" cols="2">
        <v-autocomplete
          v-model="selectedOrg"
          :items="orgName"
          label="Organisations"
          item-text="name"
          outlined
          @change="getDevicesByOrg"
        />
      </v-col>
      <v-col cols="2">
        <div class="refresh-devices">
          <v-icon 
            @click="refreshDevices"
          >
            mdi-refresh
          </v-icon>
        </div>
      </v-col>
      <v-col v-if="!isAssigned" cols="2">
      </v-col>
      <v-col cols="3">
        <div class="">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </div>
      </v-col>
      <v-col cols="3">
        <div class="download-container"> 
          <v-icon class="download-icon" @click="downloadFile">
            mdi-download
          </v-icon>
        </div>
      </v-col>
    </v-row>

    <ConfigPanel 
      v-if="vehicleDeviceConfig"
      :items="selectedVehicle"
      :groups="vehicleGroups"
      :org="orgId"
      :multi-device="isMultiDeivce"
      :nodes="nodes"
      :selected-contacts="selectedContacts"
      :vehicle-types="vehiType"
      @toggleModal="toggleInfoModal"
    />

    <InfoContainer
      :display="displayVehicleInfo"
      :width="600"
      :panel-heading="panelHeading"
      @closeModal="displayVehicleInfo = false"
    >
      <pvcam-wc-vehicle-config 
        :items="JSON.stringify(selectedVehicle)"
        :groups="JSON.stringify(vehicleGroups)"
        :org="JSON.stringify(orgId)"
        :vehicle-types="JSON.stringify(vehiType)"
        :nodes="JSON.stringify(nodes.root_node)"
        :multi-device="JSON.stringify(isMultiDeivce)"
        :admin="true"
        :translate="JSON.stringify(false)"
        @showSelectContacts="handleSelection"
      />
    </InfoContainer>

		<InfoContainer
      :display="displayDeviceInfo"
      :width="1000"
      :panel-heading="panelHeading"
      @closeModal="displayDeviceInfo = false"
    >
      <pvcam-wc-device-info
        :org="JSON.stringify(orgId)"
        :items="JSON.stringify(selectedVehicle)"
      />
    </InfoContainer>

		<InfoContainer
      :display="displayAlertConfig"
      :width="600"
      :panel-heading="panelHeading"
      @closeModal="displayAlertConfig = false"
    >
      <pvcam-wc-device-alert-config
        :items="JSON.stringify(selectedVehicle)"
        :groups="JSON.stringify(vehicleGroups)"
        :org="JSON.stringify(orgId)"
        :vehicle-types="JSON.stringify(vehiType)"
        :nodes="JSON.stringify(nodes)"
        :multi-config="JSON.stringify(displayMultiConfig)"
        :selected-contacts="JSON.stringify(selectedContacts)"
        :user-info="JSON.stringify({})"
				:admin-user="true"
      />
    </InfoContainer>
    
    <AssignedDevicesTable 
      v-if="deviceType == 'Assigned'"
      :data="devices"
      :search="search"
      :loading="loading"
      :org="orgId"
      @unassignDevice="setUnassignTarget"
      @showInfoModal="setSelectedVehicle"
      @toggleFormat="toggleFormat"
      @toggleReboot="toggleReboot"
      @toggleDeviceConfig="toggleDeviceConfig"
      @toggleLogComp="toggleLogComp"
      @toggleJobCreation="toggleJobCreation"
      @toggleConfigComponent="toggleConfigComponent"
    />
    <PendingDevicesTable 
      v-if="deviceType == 'Pending'"
      :data="devices"
      :search="search"
      :loading="loading"
      @updateOTC="setUpdateOTCTarget"
      @deleteDevice="setDeleteDeviceTarget"
    />

    <UnassignedDevicesTable 
      v-if="deviceType == 'Unassigned'"
      :data="devices"
      :search="search"
      :loading="loading"
      @deleteDevice="setDeleteDeviceTarget"
      @toggleAssignmentComp="toggleAssignmentComp"
      @showUnassignedInfoModal="showInfoModal"
      @selectionUpdated="selectionUpdated"
      @toggleFormat="toggleFormat"
      @toggleReboot="toggleReboot"
      @toggleDeviceConfig="toggleDeviceConfig"
    />

    <DeviceAssignment
      v-if="showDeviceAssignment"
      :orgs="orgs"
      :selected-devices="selectedDevices"
      @closeDeviceAssignment="toggleAssignmentComp"
      @deviceSelectedForInstall="deviceSelectedForInstall"
      @closeAllAssignmentWindows="toggleAssignmentComp"
      @refresh="getUnassignedDevices(0)"
    />

    <!-- Unassign Device prompt message -->
    <Prompt
      :display="displayUnassignPrompt"
      :close-target="'closeUnassign'"
      :submit-target="'submitUnassign'"
      :title="'Unassign Device'"
      :message="'Are you sure you wish to unassign this device?'" 
      :state="unassignState"
      :res="unassignRes"
      @closeUnassign="toggleUnassignPrompt"
      @submitUnassign="unassignDevice"
    />

    <!-- Update OTC prompt message -->
    <Prompt
      :display="displayUpdateOTC"
      :close-target="'closeUpdateOTC'"
      :submit-target="'submitUpdateOTC'"
      :title="'Update OTC'"
      :message="'Are you sure you wish to update the OTC?'" 
      :state="updateState"
      :res="updateRes"
      @closeUpdateOTC="toggleUpdateOTC"
      @submitUpdateOTC="regenOTC"
    />

    <!-- Delete device prompt message -->
    <Prompt
      :display="displayDeleteDevice"
      :close-target="'closeDeleteDevice'"
      :submit-target="'submitDeleteDevice'"
      :title="'Delete Device'"
      :message="'Are you sure you wish to delete this device?'"
      :state="deleteState" 
      :res="deleteRes"
      @closeDeleteDevice="toggleDeleteDevicePrompt"
      @submitDeleteDevice="deleteDevice"
    />

    <DeviceFormat 
			v-if="displayFormat"
			:device="formatItem"
			:org="orgId"
			@close="toggleFormat(null)"
    />
    
    <DeviceReboot 
			v-if="displayReboot"
			:org="orgId"
			:device="rebootDevice"
			@close="toggleReboot(null)"
		/>

    <DeviceConfig 
			v-if="displayDeviceConfig"
      :key="compKey"
			:item="selectedDevice"
			:org="orgId"
      :device-id="selectedDevice.id"
      @closeDeviceConfig="displayDeviceConfig = !displayDeviceConfig"
      @forceUpdateConfig="handleForceUpdate"
    />

    <DownloadLog 
			:display="showLogs"
			:device="logItem" 
			:org="orgId"
			@closeLogComp="closeLogComp"
		/>

    <add-job 
      :key="refreshAddJob"
			:open="jobVisibility" 
			:mode="'new'" 
			:job-item="jobItem"
			@exit="toggleJobCreation(null)"
		/>
  </div>
</template>

<script>
import { 
  GetOrgDevices, 
  GetOrgTree, 
  GetPendingDevicesByOrg,
  GetUnassignedDevices, 
  UnassignDeviceFromVehicle,
  RegenerateOTC,
  DeletePendingDevice,
  DeleteUnassignedDevice,
  GetOrgVehicles
  } from '@/services/API.js';

import { mapState, mapActions, mapMutations } from "vuex";
import AssignedDevicesTable from './components/AssignedDevicesTable.vue';
import PendingDevicesTable from './components/PendingDevicesTable.vue';
import UnassignedDevicesTable from './components/UnassignedDevicesTable.vue';
import DeviceAssignment from './components/DeviceAssignment.vue';
import ConfigPanel from './components/ConfigPanel.vue';
import Prompt from '@/components/general/Prompt.vue';
import DeviceFormat from '@/components/general/DeviceFormat.vue';
import DeviceReboot from '@/components/general/DeviceReboot.vue';
import DeviceConfig from '@/components/deviceConfig/config.vue';
import DownloadLog from '@/views/OrgVehicles/components/DownloadLog.vue';
import AddJob from "@/views/Jobs/Sections/AddJob.vue";
import InfoContainer from '@/components/general/InfoContainer.vue';

import moment from "moment";
import xlsx from 'xlsx';

// logger
import { Logger } from "aws-amplify"
const logger = new Logger("Device Management")

export default {
  name: 'DeviceManagement',
  components: {
    AssignedDevicesTable,
    UnassignedDevicesTable,
    PendingDevicesTable,
    DeviceAssignment,
    ConfigPanel,
    DownloadLog,
    Prompt,
    DeviceFormat,
    DeviceReboot,
    DeviceConfig,
    AddJob,
    InfoContainer
  },
  data() {
    return {
      compKey: 0,
      search: '',
      availableTags: [],
      devices: [],
      selectedOrg: '',
      loading: false,
      deviceType: '',
      deviceTypes: [
        'Assigned',
        'Unassigned',
        'Pending'
      ],
      vehicles: [],
      showDeviceAssignment: false,
      vehicleDeviceConfig: false,
      selectedVehicleDevice: [],
      selectedVehicle: [],
      nodes: {},
      vehicleGroups: [],
      displayUnassignPrompt: false,
      unassignTarget: {},
      displayUpdateOTC: false,
      updateOTCTarget: {},
      displayDeleteDevice: false,
      deleteDeviceTarget: {},
      selectedDevices: [],
      selectedDevice: {},
      unassignState: false,
      unassignRes: null,
      updateState: false,
      updateRes: null,
      deleteState: false,
      deleteRes: null,
      displayDeviceConfig: false,
      tableHeadings: {
        Unassigned: {
          headers: [
            {
              text: 'OTC',
              value: 'otc',
              align: 'left'
            },
            {
              text: 'Install Tag',
              value: 'install_tag',
              align: 'left'
            },
            {
              text: 'IMEI',
              value: 'imei',
              align: 'left'
            },
            {
              text: 'Model',
              value: 'model',
              align: 'left'
            },
            {
              text: 'Firmware Version',
              value: 'firmware',
              align: 'left'
            },
            {
              text: 'Actions',
              value: 'actions',
              align: 'left'
            }
          ]
        },
        Assigned: {
          headers: [
            {
              text: 'IMEI',
              value: 'imei',
              align: 'left'
            },
            {
              text: 'Vehicle',
              value: 'vehicle',
              align: 'left'
            },
            {
              text: 'Model',
              value: 'model',
              align: 'left'
            },
            {
              text: 'Firmware',
              value: 'firmware',
              align: 'left'
            },
            {
              text: 'Actions',
              value: 'actions',
              align: 'left'
            }
          ]
        },
        Pending: {
          headers: [
            {
              text: 'OTC',
              value: 'Profile.otc',
              align: 'left'
            },
            {
              text: 'Org Tag',
              value: 'org',
              align: 'left'
            },
            {
              text: 'Actions',
              value: 'actions',
              align: 'left'
            }
          ]
        }
      },

      displayFormat: false,
			formatItem: null,
      
      displayReboot: false,
			rebootDevice: null,
      selectedContacts: [],

      showLogs: false,
      logItem: {},

      jobVisibility: false,

      jobItem: null,
      refreshAddJob: 0,
      
      displayVehicleInfo: false,
			displayDeviceInfo: false,
			displayAlertConfig: false,
			multiDevices: false,
			displayMultiConfig: false
    }
  },
  computed: {
    ...mapState([
      'vehiType',
      'orgs'
    ]),
    isMultiDeivce() {
      return this.selectedVehicle.length > 1 ? true : false;
    },
    sortedOrgs() {
      return [...this.orgs].sort((a, b) => a.name.localeCompare(b.name));
    },
    orgName() {
      	const orgs = this.sortedOrgs.map((org) => ({
					name: org.name
				}));

        return orgs;
    },
    orgId() {
      return this.retrunOrgID(this.selectedOrg);
    },
    isAssigned() {
      return this.deviceType != 'Unassigned' ? true : false;
    },
    panelHeading() {
      return this.selectedVehicle.length > 0 
        ? this.selectedVehicle.length > 1 ? 'Multiple Vehicles Selected' : this.selectedVehicle[0].vehicle_name
        :
        '';
    }
   },
  watch: {
    deviceType() {
      // Reset devices table contents upon changing device type e.g assigned, unassignd...
      this.devices = [];
    },
    selectedOrg (val) {
      if(val) {
        const id = this.retrunOrgID(val);

        this.setOrgToWatch(id);
      }
    },
  },
  beforeMount() {
    this.getVehiType();
  },
  mounted() {
    //  Preselect device type dropdown
    this.deviceType = this.deviceTypes[0];
    this.getOrgs();
    window.$translate = (section, value) => {
      logger.info('translate', section, value)
    }
  },
  methods: {
    ...mapActions(["getOrgs", "getVehiType"]),
    toggleConfigComponent(item, display) {
      logger.info(item, display)
      const vehicle = this.vehicles.find((vehicle) => {
        return vehicle.devices.some((device) => {
          return device.device_id === item.id;
        });
      });
      const selectedAmount = this.selectedVehicle.length;
      const displayBoolMap = {
        vehicle: this.displayVehicleInfo,
        device: this.displayDeviceInfo,
        alert: this.displayAlertConfig
      }

      if (vehicle) {
        if(!this.selectedVehicle.includes(vehicle)) {
          this.selectedVehicle = [vehicle];
        }
      } else {
        // Clear selection for single select
        if (selectedAmount === 1 && displayBoolMap[display]) {
          this.selectedVehicle = [];
        }
      }

      switch (display) {
        case 'vehicle': {
          this.displayVehicleInfo = !this.displayVehicleInfo;

          break;
        }
        case 'device': {
          this.displayDeviceInfo = !this.displayDeviceInfo;

          break;
        }
        case 'alert': {
          this.displayAlertConfig = !this.displayAlertConfig;

          break;
        }
      }
    },
    ...mapMutations('presence', ['setOrgToWatch']),
    toggleJobCreation(item) {
        this.refreshAddJob++;
				this.jobVisibility = !this.jobVisibility;

				if(!item) return;
        
        const vehicle = this.vehicles.find(vehicle => {
          return vehicle.devices.some((device) => {
            return device.device_id == item.id;
          });
        })

        this.jobItem = vehicle;
			},
    handleSelection(selection, target) {
      this.selectedContacts = {
        users: selection,
        context: target
      };
    },
    handleForceUpdate() {
      this.compKey++;
    },
    batchDeviceRequest (id) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async res => {
        try {
          // we need some arbitrary limit to prevent loading forever
          const maxPages = 10
          let currentPage = 0
          let more = true
          let fullList = []
          while(currentPage < maxPages && more) {
            let list = await GetOrgDevices(id, `page_num=${currentPage}&rows_per_page=1000&order_by=id`)
            if(list && list.Devices && Array.isArray(list.Devices) && list.Devices.length) {
              fullList = fullList.concat(list.Devices)

              if(list.Devices.length < 1000) {
								more = false
							}
            } else {
              more = false
            }
            currentPage++
          }
          res({Devices: fullList})
        } catch {
          res([])
        }  
      }) 
    },
    closeLogComp() {
      this.showLogs = false;
    },
    toggleLogComp(item) {
      const vehicle = this.vehicles.find((vehicle) => {
        return vehicle.devices.some((device) => {
          return device.device_id === item.id;
        });
      })
      this.showLogs = !this.showLogs;
      this.logItem = vehicle;
    },
    toggleDeviceConfig(item) {
      logger.info('toggleDeviceConfig called', item)
      this.selectedDevice = item;
      this.displayDeviceConfig = !this.displayDeviceConfig;
    },
    toggleFormat(item) {
      this.displayFormat = !this.displayFormat;

      if (item) {
        // We have to create these new properties on the object so that it remains compatible with the vehicles page
        let devices = [{
          is_defaultdevice: true,
          device_id: item.id
        }];

        item.devices = devices;
      }
      this.formatItem = item;
    },
    toggleReboot(item) {
      this.displayReboot = !this.displayReboot;

      if (item) {
        // We have to create these new properties on the object so that it remains compatible with the vehicles page
        let devices = [{
          is_defaultdevice: true,
          device_id: item.id
        }];

        item.devices = devices;
      }

      this.rebootDevice = item;
    },
    async setDeviceTypeQuery(val) {
      if (val == 'Unassigned') {
        await this.getUnassignedDevices(0);
      }
      else {
        if (this.selectedOrg.length > 0) {
          this.getDevicesByOrg();
        }
      }
    },
    async getDevicesByOrg() {
      this.devices = [];

      if (this.selectedOrg.length > 0) {
        this.loading = true;
        let id = this.retrunOrgID(this.selectedOrg);
        let nodes = await GetOrgTree(id);
        let devices;
        let vehicles;

        const getDevicesPromise = new Promise(async res => {
          if (this.deviceType == 'Assigned') {
            devices = await this.batchDeviceRequest(id);
            logger.debug("device list", devices)
            res(true)
          } else if (this.deviceType == 'Pending') {
            devices = await GetPendingDevicesByOrg(id);
            res(true)
          }
        })

        const vehiclesPromise = new Promise(async res => {
          vehicles = await GetOrgVehicles(this.orgId, true)
          res(true)
        })
        
        await Promise.all([vehiclesPromise, getDevicesPromise])

        if (nodes) {
          this.nodes = nodes;
        }
        

        this.vehicles = vehicles;
        // Get all possible vehicle groups  
        if (vehicles.length > 0 && nodes) {
          this.vehicleGroups = this.flattenOrgTree([nodes.root_node])
        }

        if(devices.Devices) {
          this.devices = devices.Devices;
          this.loading = false;
        }
        else {
          logger.info('There was an error', devices);
          this.loading = false;
        }
      }
    },
    async getUnassignedDevices(page, items = []) {
      this.loading = true;

      let set = items;
      let index = page;
      let devices = await GetUnassignedDevices(page)
      
      
      if(devices.Devices) {
        for (let device in devices.Devices) {
          set.push(devices.Devices[device]);
          this.devices.push(devices.Devices[device])
        }

        if (devices.Devices.length >= 50) {
          index++;

          this.getUnassignedDevices(index, set);
        } else {
          this.loading = false;
        }
      }
      else {
        this.loading = false;
      }
    },
    refreshDevices() {
      if (this.deviceType == 'Unassigned') {
        this.devices = [];
        this.getUnassignedDevices(0);
      }
      else {
        this.getDevicesByOrg();
      }

      const orgId = this.retrunOrgID(this.selectedOrg);
      this.setOrgToWatch(orgId);
    },
    retrunOrgID(name) {
      let org = this.orgs.find(org => {
        return org.name == name;
      });

      return org ? org.id : '';
    },
    launchRowAction(e) {
      let allOptions = document.querySelectorAll(".report-action-options");

      for (let option of allOptions) {
        option.classList.remove('active-options');
        if (option === e.target.nextSibling) {
          option.classList.toggle('active-options');
        } 
      }
    },
    toggleAssignmentComp() {
      this.showDeviceAssignment = !this.showDeviceAssignment;
    },
    setSelectedVehicle(item) {
      let vehicle = this.vehicles.find(vehicle => {
        return vehicle.devices.some((device) => {
          return device.device_id == item.id;
        });
      })

      this.selectedVehicle = [vehicle];
      this.toggleInfoModal();
    },
    showInfoModal(item) {
      this.selectedVehicleDevice = [item];
      this.toggleInfoModal();
    },
    toggleInfoModal() {
      this.vehicleDeviceConfig = !this.vehicleDeviceConfig;
    },
    setUnassignTarget(item) {
      this.unassignRes = null;
      this.unassignTarget = item;
      this.toggleUnassignPrompt();
    },
    toggleUnassignPrompt() {
      this.displayUnassignPrompt = !this.displayUnassignPrompt;
    },
    setUpdateOTCTarget(item) {
      this.updateRes = null;
      this.updateOTCTarget = item;
      this.toggleUpdateOTC();
    },
    toggleUpdateOTC() { 
      this.displayUpdateOTC = !this.displayUpdateOTC;
    },
    setDeleteDeviceTarget(item, type) {
      logger.info('device type for deletion',item, type)
      this.deleteRes = null;
      this.deleteDeviceTarget = item;
      // Sets the state to either unassigned or pending
      this.deleteDeviceTarget.state = type;
      this.toggleDeleteDevicePrompt();
    },
    toggleDeleteDevicePrompt() {
      this.displayDeleteDevice = !this.displayDeleteDevice;
    },
    async unassignDevice() {
      this.unassignState = false;

      let vehicleId = '';
      let deviceId = this.unassignTarget.id;
      let orgId = this.retrunOrgID(this.selectedOrg);
      
      logger.info('unassign device : ', orgId, vehicleId, deviceId);

      const unasign = await UnassignDeviceFromVehicle(orgId, vehicleId, deviceId);

      if (unasign) {
        this.refreshDevices();

        this.unassignRes = {
          msg: 'Device Unassigned Successfully',
          code: 'green'
        }
      } else {
        this.unassignRes = {
          msg: 'Device Unassignment Failed',
          code: 'red'
        }
      }
      this.unassignState = true;
      this.unassignTarget = {};
    },
    async regenOTC() {
      this.updateState = false;

      let id = this.updateOTCTarget.id;

      const update = await RegenerateOTC(id);

      if (update) {
        this.refreshDevices();

        this.updateRes = {
          msg: `Updated OTC : ${update.otc}`,
          code: 'green'
        }
      } else {
        this.updateRes = {
          msg: 'OTC Regeneration failed',
          code: 'red'
        }
      }

      this.updateState = true;
      this.updateOTCTarget = {}
    },
    async deleteDevice() {
      this.deleteState = false;

      let id = this.deleteDeviceTarget.id;
      let deleteItem = null;

      if(this.deleteDeviceTarget.state == 'pending') {
        deleteItem = await DeletePendingDevice(id);
      }
      if(this.deleteDeviceTarget.state == 'unassigned') {
        deleteItem = await DeleteUnassignedDevice(id);
      }

      if (deleteItem) {
        this.refreshDevices();
        
        this.deleteRes = {
          msg: 'Device Deleted Successfully',
          code: 'green'
        }
      } else {
        this.deleteRes = {
          msg: 'Device Deletion failed',
          code: 'red'
        }
      }

      this.deleteState = true;
      this.deleteDeviceTarget = {}
    },
    selectionUpdated(data) {
      this.selectedDevices = data;
    },
    deviceSelectedForInstall(data) {
      logger.info('deviceSelectedForInstall : ', data);
    },
    flattenOrgTree(node) {
      var result = [];
      
      node.forEach((a) => {
          result.push(a.metadata.label);
          if (Array.isArray(a.nodes)) {
            result = result.concat(this.flattenOrgTree(a.nodes));
          }
      });
      return result;
    },
    returnVehicleGroup(id, node) {
      let result;

      if (Object.values(node).indexOf(id) > -1) {
        return node;
      } else {
        for (var i = 0; i < node.nodes.length; i += 1) {
          let subNode = node.nodes[i];
          
          result = this.returnVehicleGroup(id, subNode);

          if (result !== false) {
              return result;
          }
        }
        return false;
      }
    },
    downloadFile () {
      if (this.devices.length > 0) {
        // create our excel file
        const wb = xlsx.utils.book_new();
        
        // Filter unwanted fields from report
        let cleanedReportCollection = [];


        this.devices.forEach(item => {
          let cleanedReportItem = {};
          let tableHeaders = this.tableHeadings[this.deviceType].headers;

          tableHeaders.forEach(heading => {
            let key = heading.value;

            // eslint-disable-next-line no-prototype-builtins
            if (item.hasOwnProperty(key)) {             
              cleanedReportItem[key] = item[key];
            }
  
            if(!cleanedReportCollection.includes(cleanedReportItem)) {
              cleanedReportCollection.push(cleanedReportItem);
            }
          });
        });

        // create our worksheets
        const report = xlsx.utils.json_to_sheet(cleanedReportCollection);

        // apend them to the workbook
        xlsx.utils.book_append_sheet(wb, report, this.reportTitle);

        const reportName = `${this.deviceType}_${this.selectedOrg}_${moment().format("YYYY-MM-DD HH:mm:ss")}`;
        xlsx.writeFile(wb, reportName + ".xlsx");
      }
    }
  },
}
</script>

<style lang="scss">
  .device-management {
    padding: 1em 0;
    .device-control-bar {
        padding: 0 1em;
    }
    .refresh-devices {
      padding-bottom: 1em;
      &:hover {
        cursor: pointer;
      }
    }
    .download-container {
      text-align: right;
      padding-right: 1em;
      .download-icon {
        &:hover {
          cursor: pointer;
        }
      }
    }
    .reports-action-launch {
      position: relative;
      cursor: pointer;
    }
    .report-action-options {
      display: none;
    }
    .active-options {
      display: block !important;  
    }
  }
  .v-data-table__wrapper {
    overflow-x: visible !important;
    overflow-y: visible !important;
  }
</style>